import api from '@/lib/api'
import { defineStore, acceptHMRUpdate } from 'pinia'
import { ref } from 'vue'

export const useSettingsStore = defineStore('settings', () => {
  const settings = ref({
    mails: [],
    daysfordeletelogs: 60,
    intervalmails: {
      hours: 0,
      minutes: 0
    },
    newanomalytemplate: { mail: { subject: null, body: null }, notification: { title: null, body: null } },
    periodicanomalytemplate: { mail: { subject: null, body: null }, notification: { title: null, body: null } },
    closeanomalytemplate: { mail: { subject: null, body: null }, notification: { title: null, body: null } }
  })

  const initializeSettings = async () => {
    const { data } = await api.settings.getSettings()
    Object.keys(data).forEach(key => { settings.value[key] = data[key] })
  }

  const saveSettings = async (newSettings) => {
    const { data } = await api.post('/hk/v1/settings', { newSettings })
    Object.keys(data).forEach(key => { settings.value[key] = data[key] })
  }

  return {
    settings,
    initializeSettings,
    saveSettings
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useSettingsStore, import.meta.hot))
}
